exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".play{width:100%;height:100%;overflow:hidden}.play .play-iframe{width:100%;height:100%;border-width:0;border:none;margin:0;padding:0}", ""]);

